import { State } from 'store/store';

export function transformScoreDataFromIdToSId(
  scoreData: { [key: string]: true | false | 0 | 1 },
  state: State
) {
  const { blocks } = state;
  const idToSid = Object.keys(scoreData).reduce((acc, curr) => {
    let sId = blocks[curr]?.props?.sId;

    return {
      ...acc,
      // if we can't get an sId we default to the id ( curr )
      [sId || curr]: tF(scoreData[curr]),
    };
  }, {});

  return idToSid;
}

export function transformScoreDataFromSIdToId(
  scoreData: { [key: string]: 't' | 'f' | 0 | 1 },
  state: State
) {
  const sIdToId = Object.keys(scoreData).reduce((acc, curr) => {
    const blockWithSIdOrId = Object.values(state.blocks).find(block => {
      if (block?.props?.sId === Number(curr)) {
        return true;
      }

      return block?.id === curr;
    });

    if (!blockWithSIdOrId) {
      return acc;
    }

    return {
      ...acc,
      [blockWithSIdOrId.id]: tF(scoreData[curr]),
    };
  }, {});

  return sIdToId;
}

function tF(value: 't' | 'f' | true | false | 1 | 0) {
  switch (value) {
    case 't': {
      return true;
    }

    case 'f': {
      return false;
    }

    case true: {
      return 't';
    }

    case false: {
      return 'f';
    }

    default: {
      return value;
    }
  }
}
